import { render, staticRenderFns } from "./singleRowBox.vue?vue&type=template&id=c010d812&"
import script from "./singleRowBox.vue?vue&type=script&lang=js&"
export * from "./singleRowBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports